export const locales = ['fr', 'en'] as const
export type Locale = (typeof locales)[number]
export const defaultLocale: Locale = 'fr'

export function isLocale(value: string | undefined | null): value is Locale {
  return !!value && (locales as readonly string[]).includes(value)
}

/**
 * Language for a visitor whose URL has no locale yet (app.callizy.ca, /login…):
 * the one they chose before, else their browser's. An English browser must not
 * land on a French page: Chrome then translates the whole app and mangles names
 * (28 Oct 2026, "Issler" shown as "Isler").
 */
export function localeDArrivee(): Locale {
  try {
    const stored = localStorage.getItem('preferred_locale')
    if (isLocale(stored)) return stored
  } catch {
    // localStorage unavailable (Safari private mode): fall back to the browser
  }
  if (typeof navigator !== 'undefined') {
    const langues = navigator.languages?.length ? navigator.languages : [navigator.language]
    for (const langue of langues) {
      const code = (langue || '').toLowerCase().slice(0, 2)
      if (isLocale(code)) return code
    }
  }
  return defaultLocale
}

export function getLocaleFromPath(pathname: string): Locale {
  const segment = pathname.split('/')[1]
  return isLocale(segment) ? segment : localeDArrivee()
}
